<template>
  <div>
    <svg :width="size" :height="size" style="margin-right: 10px">
      <circle
        v-if="iconType === shapes[0]"
        :cx="size / 2.0"
        :cy="size / 2.0"
        :r="size / 4"
        stroke="black"
        stroke-width="0"
        fill="white"
      />
      <rect
        v-if="iconType === shapes[1]"
        :width="(size - 6) / 2.0"
        :height="(size - 6) / 2.0"
        :x="-(size - 6) / 4.0"
        :y="-(size - 6) / 4.0"
        :transform="`translate(${size / 2.0},${size / 2.0}) rotate(45)`"
        fill="white"
      />
      <g v-if="iconType === shapes[2]">
        <line
          :x1="size / 4.0"
          :y1="size / 2"
          :x2="(size * 3) / 4.0"
          :y2="size / 2"
          stroke="white"
          stroke-width="2"
        />
        <line
          :x1="size / 3.0"
          :y1="size / 2"
          :x2="size * (2 / 3.0)"
          :y2="size / 2"
          stroke="black"
          stroke-width="2"
        />
        <line
          :x1="size / 2"
          :y1="size / 4.0"
          :x2="size / 2.0"
          :y2="(size * 3) / 4.0"
          stroke="white"
          stroke-width="2"
        />
        <line
          :x1="size / 2"
          :y1="size / 3.0"
          :x2="size / 2.0"
          :y2="size * (2 / 3.0)"
          stroke="black"
          stroke-width="2"
        />
      </g>
      <rect
        v-if="iconType === shapes[3]"
        :x="size / 4.0"
        :y="size / 4.0"
        :width="size / 2.0"
        :height="size / 2.0"
        fill="balck"
        stroke-with="2"
        stroke="white"
      />
      <g v-if="iconType === shapes[4]">
        <line
          :x1="size / 4.0"
          :y1="size / 2"
          :x2="(size * 3) / 4.0"
          :y2="size / 2"
          stroke="white"
          stroke-width="4"
        />
        <line
          :x1="size / 4.0"
          :y1="size / 2"
          :x2="(size * 3) / 4.0"
          :y2="size / 2"
          stroke="black"
          stroke-width="1"
        />
        <line
          :x1="size / 2"
          :y1="size / 4.0"
          :x2="size / 2.0"
          :y2="(size * 3) / 4.0"
          stroke="white"
          stroke-width="4"
        />
        <line
          :x1="size / 2"
          :y1="size / 4.0"
          :x2="size / 2.0"
          :y2="(size * 3) / 4.0"
          stroke="black"
          stroke-width="1"
        />
      </g>
      <g v-if="iconType === shapes[5]">
        <line
          :x1="size / 4.0"
          :y1="size / 2"
          :x2="(size * 3) / 4.0"
          :y2="size / 2"
          stroke="black"
          stroke-width="2"
        />
        <line
          :x1="size / 4.0"
          :y1="size / 2"
          :x2="(size * 3) / 4.0"
          :y2="size / 2"
          stroke="white"
          stroke-width="2"
          stroke-dasharray="5 5"
        />
      </g>
      <text
        v-if="iconType === shapes[6]"
        :x="size / 2 - 10"
        :y="size / 2 + 8"
        fill="white"
        font-size="18"
      >
        NT
      </text>
      <text
        v-if="iconType === shapes[7]"
        :x="size / 2 - 10"
        :y="size / 2 + 8"
        fill="white"
        font-size="18"
      >
        {{ eyeType }}
      </text>
      <g v-if="iconType === shapes[8]">
        <circle
          :cx="size / 2.0"
          :cy="size / 2.0"
          :r="size / 4"
          stroke="white"
          fill="none"
          stroke-width="2"
        />
        <circle
          :cx="size / 2.0"
          :cy="size / 2.0"
          :r="size / 4"
          stroke="black"
          fill="none"
          stroke-width="2"
          stroke-dasharray="5 3"
        />
      </g>
      <g v-if="iconType === shapes[9]">
        <circle
          :cx="size / 2.0"
          :cy="size / 2.0"
          :r="size / 4"
          stroke="white"
          fill="none"
          stroke-width="2"
        />
        <line
          :x1="size / 4"
          :y1="0"
          :x2="size / 4 + 8"
          :y2="0"
          stroke="white"
          stroke-width="3"
          :transform="`translate(${size / 2.0},${size / 2.0}) rotate(45)`"
        />
      </g>
    </svg>
  </div>
</template>
<script>
import { DATASHAPSONMAP } from "../shared/index";
export default {
  name: "IconShape",
  data() {
    return {
      shapes: DATASHAPSONMAP
    };
  },
  mounted() {},
  props: {
    size: {
      type: Number,
      default: 20
    },
    iconType: {
      type: String,
      default: DATASHAPSONMAP[0]
    },
    eyeType: {
      type: String,
      default: "OS"
    }
  }
};
</script>
<style scoped>
.br {
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/topography/components/IconShape.vue